import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CTAButton = ({ 
  children, 
  to, 
  href, 
  variant = 'contained', 
  color = 'primary', 
  fullWidth = false,
  size = 'large',
  ...props 
}) => {
  const MotionButton = motion(Button);

  const buttonProps = {
    variant,
    color,
    size,
    fullWidth,
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.98 },
    sx: {
      py: 1.5,
      px: 4,
      fontSize: '1.1rem',
      fontWeight: 600,
      ...props.sx,
    },
    ...props,
  };

  if (to) {
    return (
      <MotionButton component={Link} to={to} {...buttonProps}>
        {children}
      </MotionButton>
    );
  }

  if (href) {
    return (
      <MotionButton href={href} {...buttonProps}>
        {children}
      </MotionButton>
    );
  }

  return <MotionButton {...buttonProps}>{children}</MotionButton>;
};

export default CTAButton;
